import { Box, Typography } from "@mui/material";
import logo from "../assets/phoenix-logo.png";

const Header = () => {
  return (
    <Box sx={{ py: "18px", px: "12px", height: "70px" }} >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, }} >
        <Box
          component="img"
          src={logo}
          alt="Phoenix Play Zone"
          sx={{
            height: "34px",
            width: "34px",
            objectFit: "contain",
          }}
        />
        <Typography variant="body1" sx={{ color: "gray", letterSpacing: "0.3px" }} >
          Phoenix Play Zone
        </Typography>
      </Box>
    </Box>
  );
};

export default Header;
